import React from "react";
import {
  analyzeError,
  getErrorBadge,
  getErrorIcon,
  getErrorSuggestedAction,
} from "../../utils/analysisFormatter";

/**
 * Component hiển thị lỗi một cách có cấu trúc (Structured Error Display)
 */
export const ErrorSection = ({ error }) => {
  if (!error) return null;

  const errorAnalysis = analyzeError(error);

  return (
    <section className="bg-white border-2 border-red-200 rounded-2xl p-4 sm:p-6 shadow-sm space-y-4">
      <div className="flex items-center gap-2">
        <h4 className="text-base font-semibold text-red-900 flex items-center gap-2">
          <span className="text-lg">⚠️</span>
          Lỗi Xử Lý
        </h4>
        <span
          className={`text-xs uppercase font-bold px-3 py-1 rounded-full border ${getErrorBadge(
            errorAnalysis.severity
          )}`}
        >
          {errorAnalysis.severity.toUpperCase()}
        </span>
      </div>

      <div className="space-y-3">
        {/* Error Type */}
        <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
          <div className="text-2xl flex-shrink-0">
            {getErrorIcon(errorAnalysis.errorType)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs uppercase text-gray-600 font-semibold mb-1">
              Loại Lỗi
            </p>
            <p className="text-sm font-mono text-gray-900 break-all">
              {errorAnalysis.errorType}
            </p>
          </div>
        </div>

        {/* Error Message */}
        <div className="p-3 bg-red-50 rounded-lg border border-red-200">
          <p className="text-xs uppercase text-red-700 font-semibold mb-2">
            Chi Tiết Lỗi
          </p>
          <p className="text-sm text-red-900 whitespace-pre-wrap break-words max-h-32 overflow-y-auto">
            {errorAnalysis.message}
          </p>
        </div>

        {/* Suggested Action */}
        <div className="p-3 bg-yellow-50 rounded-lg border border-yellow-200 flex items-start gap-3">
          <span className="text-lg flex-shrink-0">💡</span>
          <div className="flex-1 min-w-0">
            <p className="text-xs uppercase text-yellow-700 font-semibold mb-1">
              Hành Động Đề Xuất
            </p>
            <p className="text-sm text-yellow-900">
              {getErrorSuggestedAction(errorAnalysis.errorType)}
            </p>
          </div>
        </div>

        {/* Retry Option */}
        {errorAnalysis.isRetryable && (
          <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-900 flex items-center gap-2">
              <span className="text-lg">🔄</span>
              <span>Có thể thử lại yêu cầu này</span>
            </p>
          </div>
        )}
      </div>

      {/* Raw Error for debugging */}
      <details className="mt-4">
        <summary className="cursor-pointer text-xs uppercase text-gray-600 font-semibold hover:text-gray-900">
          📋 Chi tiết kỹ thuật (Raw Error)
        </summary>
        <pre className="mt-2 p-3 bg-gray-900 text-green-400 rounded text-xs overflow-x-auto max-h-48 overflow-y-auto font-mono">
          {typeof error === "string" ? error : JSON.stringify(error, null, 2)}
        </pre>
      </details>
    </section>
  );
};

export default ErrorSection;
